import { render, staticRenderFns } from "./MessageVerify.vue?vue&type=template&id=6d51f2b8&scoped=true&"
import script from "./MessageVerify.vue?vue&type=script&lang=ts&"
export * from "./MessageVerify.vue?vue&type=script&lang=ts&"
import style0 from "./MessageVerify.vue?vue&type=style&index=0&id=6d51f2b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51f2b8",
  null
  
)

export default component.exports